import Swiper, { Navigation } from "swiper";

export default class FeaturedDevelopments {
    constructor() {
        this.slider = '.js-featured-developments';
        
        this.init();
    }

    init() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            loop: false,
            spaceBetween: 8,
            slidesPerView: 1.15,
            allowTouchMove: true,
            threshold: 20,
            navigation: {
                nextEl: ".js-featured-developments-next",
                prevEl: ".js-featured-developments-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1,
                }
            }
        });

    }
}

new FeaturedDevelopments;